import { bindServices } from '@/services/api';

const api = bindServices('dashboard');
const now = new Date();

const Model = {
  namespace: 'dashboard',
  state: {
    currentYear: now.getFullYear(),
    currentMonth: now.getMonth() + 1,
    managementBox: {
      planRequestsCount: 0,
      planTotalSpace: 0,
      spaceUsed: 0,
      totalEnabledProcess: 0,
      totalEnabledUsers: 0,
      totalProcess: 0,
      totalRequestsCount: 0,
      totalUsers: 0,
      aiConsumptions: [],
    },
    mostUsedProcess: [],
    requests: {
      totalApprovedRequests: 0,
      totalCanceledRequests: 0,
      totalPendingRequests: 0,
      totalReceivedRequests: 0,
      totalRejectedRequests: 0,
      totalRequests: 0,
      totalSentRequests: 0,
      totalVoidedRequests: 0,
    },
    lastSentTasks: [],
    pendingTasks: [],
    requestsByMonth: [],
    mainCollaborators: [],
  },
  effects: {
    *init({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, { route: 'dashboard', ...payload });
        yield put({
          type: 'queryBoard',
          payload: { ...payload, response },
        });
      } catch (e) {}
    },

    *resetCurrentYearMonth(__, { put }) {
      yield put({ type: 'queryCurrentYearMonth' });
    },
  },
  reducers: {
    queryBoard(state, { payload }) {
      const { month, year, response } = payload;
      return {
        ...state,
        ...response,
        currentYear: year,
        currentMonth: month >= 0 ? month : 'all',
      };
    },

    queryCurrentYearMonth(state) {
      return {
        ...state,
        currentYear: now.getFullYear(),
        currentMonth: now.getMonth() + 1,
      };
    },
  },
};

export default Model;
